import React, { useState, useEffect, useCallback } from 'react';

import GoogleAuthScopeContext from './GoogleAuthScopeContext';

export default ({ localStorageKey, children }) => {
    const [hasScopeBeenApproved, setHasScopeBeenApproved] = useState(null);

    useEffect(() => {
        setHasScopeBeenApproved(
            Boolean(window.localStorage.getItem(localStorageKey))
        );
    }, []);

    const handleSetHasScopeBeenApproved = useCallback((scopeApproved) => {
        window.localStorage.setItem(localStorageKey, scopeApproved);
        setHasScopeBeenApproved(scopeApproved);
    }, []);

    return (
        <GoogleAuthScopeContext.Provider
            value={{
                isLoading: false,
                hasScopeBeenApproved,
                setHasScopeBeenApproved: handleSetHasScopeBeenApproved,
            }}
        >
            {children}
        </GoogleAuthScopeContext.Provider>
    );
};
